<ng-container>
  <section class="event-file-manager-wrapper"
           *ngIf="selectedEvent && ((prettyFileList && prettyFileList.length >0) ||
            (mergedImageReferences && mergedImageReferences.length>0) ||
            (mergedVideoReferences && mergedVideoReferences.length>0)); else no_files ">
    <div class="event-extra-information-header">
      <div class="event-files-wrapper" horizontalMouseWheel>
        <div class="event-file-button" *ngIf="mergedImageReferences && mergedImageReferences.length>0"
             [ngClass]="{'active': true}"
             (click)="onChangeFile('openImages')"
        >
          <div>
            <span class="report-label">{{"All Images"|translate}}</span>
<!--            <i *ngIf="isEditable && addReportAvailable"-->
<!--               class="report-delete-icon"-->
<!--               (click)="deleteReport(eventFile); $event.stopPropagation()"-->
<!--               [ngClass]="'pancancer__icon__CrossCircle1'"></i>-->
          </div>
        </div>
        <div class="event-file-button" *ngIf="mergedVideoReferences && mergedVideoReferences.length>0"
             [ngClass]="{'active': true}"
             (click)="onChangeFile('openVideos')">
          <div>
            <span class="report-label">{{"All Videos"|translate}}</span>
          </div>
        </div>
        <div class="event-file-button" *ngFor="let eventFile of prettyFileList"
             [ngClass]="{'active': eventFile.id!=(null||undefined)?eventFile.id === selectedEventFile.id:eventFile == selectedEventFile}"
             (click)="onChangeFile(eventFile)">
          <div>
            <span class="report-label" [title]="eventFile?.name">{{escapeLabel(eventFile?.name)}}</span>
            <i *ngIf="isEditable && addReportAvailable && !eventFile.isExternalFile"
               [ngClass]='{"display-none": this.checkAddButton(false),"report-delete-icon pancancer__icon__CrossCircle1":true}'
               (click)="deleteReport(eventFile); $event.stopPropagation()"
               ></i>
          </div>

        </div>
      </div>
      <div [ngClass]='{"display-none": this.checkAddButton(false), "add-file-button add-button":true}'
           *ngIf="isEditable && addReportAvailable"
           (click)="uploadInput.click($event)">
        <i class="icon__Plus1"></i>
      </div>
    </div>
    <div class="event-gen-file-viewer-wrapper">
      <ispm-gallery-viewer
              *ngIf="eventDefinition?.ui?.eventPanel?.gallery?.showAsGallery && mergedImageReferences && mergedImageReferences.length>0 && showPanes===2"
              [thumbnailConfiguration]="eventDefinition?.ui?.eventPanel?.gallery?.widgetPayload"
              [selectedEvent]="selectedEvent"
              [thumbnailCollections]="mergedImageReferences"
              [galleryType]="'image'"
      ></ispm-gallery-viewer>
      <ispm-gallery-viewer
              *ngIf="eventDefinition?.ui?.eventPanel?.gallery?.showAsGallery && mergedVideoReferences && mergedVideoReferences.length>0 && showPanes===3"
              [thumbnailConfiguration]="eventDefinition?.ui?.eventPanel?.gallery?.widgetPayload"
              [selectedEvent]="selectedEvent"
              [thumbnailCollections]="mergedVideoReferences"
              [galleryType]="'video'"
      ></ispm-gallery-viewer>
      <gen-file-viewer
        *ngIf="selectedEventFile"
        [fileBase64Content]="selectedFileContent | async"
        [nlpConfig]="nlpConfig"
        [hasNLPHighLights]="hasNLPHighLights"
        [nlpTransformed]="nlpTransformed"
        [file]="selectedEventFile"
        [nlpType]="selectedEventNlpType"
        [reviewExtractionKey]="reviewExtractionKey"
        [findingData]="findingData"
        (onDownloadFile)="downloadFileWithBlob($event)"
        >
      </gen-file-viewer>
    </div>
  </section>
  <ng-template #no_files>
    <section class="add-first-report" *ngIf="isEditable && selectedEvent ; else event_not_selected">
      <div  *ngIf="!uploadInProgress && addReportAvailable && !eventDefinition?.ui?.addReportDisabled?true:false">
        <span class="add-button"
              (click)="uploadInput.click($event)">
          <i class="icon__Plus1"></i>
        </span>
        <span class="add-button-label">
          {{'ADD_NEW_FILE' | translate}}
        </span>
      </div>
    </section>
    <ng-template #event_not_selected>
      <section *ngIf="isEditable" class="no-event-selected">{{'NO_EVENT_SELECTED' | translate}}</section>
    </ng-template>
  </ng-template>
  <input type="file"
         class="upload-input"
         accept="{{fileExtension}}"
         (change)="onUploadInput($event)"
         #uploadInput/>
</ng-container>
